module.exports = __webpack_public_path__ + "img/word.d55b4ad4.png";